import ICommon from './interface/Common';
import ITextPages from './interface/TextPages';
import { IShop } from './interface/Shop';
import { updateCart } from './service/ajax';

document.addEventListener('DOMContentLoaded', () => {
  const localOldPage = window.localStorage.getItem(`${window.location.hostname}_lastPage`);
  if (localOldPage === 'shop-cart') {
    try {
      updateCart([]).then((response) => {
        const { total } = response.data;
        const badgeTotal = Number(document.querySelector('header [data-sm-cart-count]').textContent);

        if (total !== badgeTotal) {
          window.location.reload();
        }
      });
    } catch (e) {
      console.warn(e);
    }
  }

  const page = document.body.className.split(' ')[0] || '';
  window.localStorage.setItem(`${window.location.hostname}_lastPage`, page);

  ICommon();
  ITextPages();
  IShop.init();

  window.Dio.SHOP.CART.setProductsClassName('.cart-block-list [data-cart-product-id]');

  document.body.classList.add('js-loaded');
});

window.onload = function () {
  document.body.classList.add('window-loaded');
};
